/* Native Shopify adapter for the approved V6 PDP. Turbo owns submission/cart. */
(() => {
  function init() {
    const root = document.getElementById('lfl-comfort-pdp');
    if (!root || root.dataset.initialized === 'true') return;

    const data = root.querySelector('#lfl-pdp-data');
    if (!data) return;

    const config = JSON.parse(data.textContent);
    const $ = (s, r = root) => r.querySelector(s);
    const $$ = (s, r = root) => [...r.querySelectorAll(s)];

    const variants = {
      'Twin': { dimensions: '38″ W × 75″ L' },
      'Twin XL': { dimensions: '38″ W × 80″ L' },
      'Full': { dimensions: '54″ W × 75″ L' },
      'Queen': { dimensions: '60″ W × 80″ L' },
      'King': { dimensions: '76″ W × 80″ L' },
      'Cal King': { dimensions: '72″ W × 84″ L' },
      'Split King': { dimensions: 'Two 38″ W × 80″ L pieces' },
      'Split Cal King': { dimensions: 'Two 36″ W × 84″ L pieces' },
      'Split Queen': { dimensions: 'Two 30″ W × 80″ L pieces' }
    };

    const normalizeSize = x => String(x)
        .toLowerCase()
        .replace(/\(.*?\)/g, '')          // drop "(38 x 75)"
        .replace(/\bcalifornia\b/g, 'cal')
        .replace(/\btwin\s*extra\s*long\b/g, 'twin xl')
        .replace(/[^a-z]/g, '');

    const parseHeight = value => {
      const match = String(value).trim().match(/^(7|9|12)(?:[\s"″’-]|in|inch|$)/i);
      return match ? Number(match[1]) : null;
    };

    function selectionFor(v) {
      if (!v || !Array.isArray(v.options) || v.options.length !== 2) return null;
      const size = Object.keys(variants).find(size =>
        v.options.some(value => normalizeSize(size) === normalizeSize(value))
      );
      const height = v.options.map(parseHeight).find(Boolean);
      return size && height ? { size, height } : null;
    }

    function findVariant(product, height, size) {
      return product?.variants?.find(v => {
        const selection = selectionFor(v);
        return selection && selection.size === size && selection.height === height;
      });
    }

    const initial = config.comfort?.variants?.find(v => String(v.id) === String(config.selectedVariant));
    initialSelection=selectionFor(initial)||{size:"Queen",height:9}; // Native selector remains usable for an unconfigured catalog.

    function setPurchaseForm(buttonId, v, label) {
      const b = $('#lfl-' + buttonId);
      if (!b) return;

      const form = b.closest('form'), input = form.querySelector('[name="id"]');
      const enabled = Boolean(v && v.available && v.price > 0);
      const newId = v ? String(v.id) : '';
      const changed = input.value !== newId;

      input.value = newId;
      input.disabled = !enabled;
      b.disabled = !enabled;
      b.classList.toggle('disabled', !enabled);

      const text = b.querySelector('span');
      if (text) {
        text.textContent = enabled
          ? label
          : v && !v.available
            ? 'Sold out'
            : v && v.price <= 0
              ? 'Coming soon'
              : 'Unavailable';
      }

      if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const heightSpecs = {
      7: { soft: 2, core: 2, firm: 2, cover: 0.5, image: config.images['7'] },
      9: { soft: 2, core: 4, firm: 2, cover: 0.5, image: config.images['9'] },
      12: { soft: 3, core: 6, firm: 2, cover: 0.5, image: config.images['12'] }
    };

    let selectedHeight = 9;
    let selected = 'Queen';

    function selectHeight(value) {
      const height = Number(value), spec = heightSpecs[height];
      if (!spec) return;

      selectedHeight = height;

      const thumb = $('#lfl-construction-thumb');
      const isConstruction = thumb.classList.contains('active');
      const alt = `${height}-inch construction: a half-inch quilted cover on each side, ${spec.soft} inches of softer natural latex, a ${spec.core}-inch lighter ivory HD foam core, and ${spec.firm} inches of firmer natural latex. Solid vertical sides; pinholes only on horizontal latex faces.`;

      $$('[data-height]').forEach(b => {
        if (b.tagName !== 'BUTTON') return;
        const on = Number(b.dataset.height) === height;
        b.classList.toggle('selected', on);
        b.setAttribute('aria-pressed', String(on));
      });

      $('#lfl-height-name').textContent = height + '″';
      $('#lfl-height-summary').textContent = `${spec.soft}″ softer latex · ${spec.core}″ core · ${spec.firm}″ firmer latex`;
      $('#lfl-construction-selection').textContent = height + '″ profile';
      $('#lfl-construction-caption').textContent = `${height}″ model: ½″ cover + ${spec.soft}″ latex + ${spec.core}″ core + ${spec.firm}″ latex + ½″ cover.`;

      $$('[data-latex-depth]').forEach(el => el.textContent = '· ' + spec[el.dataset.latexDepth] + '″');
      $('#lfl-core-depth').textContent = '· ' + spec.core + '″';
      $$('[data-height-row]').forEach(row => row.classList.toggle('selected', Number(row.dataset.heightRow) === height));

      $('.layers-figure').dataset.height = String(height);
      $('#lfl-construction-image').src = spec.image;
      $('#lfl-construction-image').alt = alt;

      thumb.dataset.image = spec.image;
      thumb.dataset.alt = alt;
      thumb.querySelector('img').src = spec.image;

      if (isConstruction) {
        $('#lfl-gallery-main').src = spec.image;
        $('#lfl-gallery-main').alt = alt;
        if ($('#lfl-image-dialog').open) {
          $('#lfl-zoom-image').src = spec.image;
          $('#lfl-zoom-image').alt = alt;
        }
      }

      selectSize(selected);
    }

    $$('button[data-height]').forEach(b => b.addEventListener('click', () => selectHeight(b.dataset.height)));

    function selectSize(size) {
      if (!variants[size]) return;
      selected = size;

      const v = findVariant(config.comfort, selectedHeight, size);
      const label = v ? v.priceText : 'Unavailable';

      $('#lfl-price').textContent = label;
      $('#lfl-compare-price').textContent = v?.compareText || '';

      const saving = Boolean(v && v.compare > v.price);
      $('#lfl-compare-price').hidden = !saving;
      $('.save').hidden = !saving;
      $('.save').textContent = saving ? 'Save ' + v.savingText : '';

      $('#lfl-size-name').textContent = size;
      $('#lfl-dimensions').textContent = variants[size].dimensions + ' × ' + selectedHeight + '″ H';
      $('.button-price').textContent = v?.priceText || '';
      $('.sticky-price').textContent = size + ' · ' + selectedHeight + '″ · ' + label;

      $$('[data-size]').forEach(b => {
        const on = b.dataset.size === size;
        b.classList.toggle('selected', on);
        b.setAttribute('aria-pressed', String(on));
      });

      $('#lfl-split-size').value = size.startsWith('Split') ? size : '';

      setPurchaseForm('add-cart', v, 'Add to cart');
      setPurchaseForm('compare-add-comfort', v, 'Add Latex Comfort to cart');

      const url = new URL(window.location.href);
      if (v) url.searchParams.set('variant', v.id);
      else url.searchParams.delete('variant');
      history.replaceState(history.state, '', url);

      $('#lfl-selection-status').textContent =
        size + ', ' + selectedHeight + ' inch. ' +
        (v ? v.priceText + (v.available ? '' : ', sold out') : 'This combination is unavailable') + '.';

      root.dispatchEvent(new CustomEvent('lfl:variant-change', {
        bubbles: true,
        detail: { product: config.comfort, variant: v || null, size, height: selectedHeight }
      }));

      renderComparison();
    }

    function renderComparison() {
      const comfort = findVariant(config.comfort, selectedHeight, selected);
      const latex = selectedHeight === 12 ? null : findVariant(config.allLatex, selectedHeight, selected);
      const exists = Boolean(latex), isTwelve = selectedHeight === 12;

      $('#lfl-compare-size').value = selected;
      $('#lfl-compare-height').value = String(selectedHeight);

      $('#lfl-compare-dimensions').replaceChildren(
        document.createTextNode(variants[selected].dimensions),
        Object.assign(document.createElement('span'), { textContent: 'Prices for your selected size and height' })
      );

      $$('[data-comparison-selection]').forEach(el => el.textContent = selected + ' · ' + selectedHeight + '″ height');
      $('#lfl-compare-comfort-depth').textContent =
        heightSpecs[selectedHeight].soft + '″ softer side · ' + heightSpecs[selectedHeight].firm + '″ firmer side';
      $('#lfl-comfort-compare-price').textContent = comfort?.priceText || 'Unavailable';

      $('#lfl-all-latex-offer').hidden = !exists;
      $('#lfl-all-latex-unavailable').hidden = exists;
      $('#lfl-compare-organic-link').hidden = !isTwelve;
      $('#lfl-compare-view-nine').hidden = isTwelve || selectedHeight === 9;

      setPurchaseForm('compare-add-all-latex', latex, 'Add All-Latex to cart');

      if (exists) {
        $('#lfl-all-latex-compare-price').textContent = latex.priceText;
        const saving = latex.compare > latex.price;
        $('#lfl-all-latex-was-price').hidden = !saving;
        $('#lfl-all-latex-savings').hidden = !saving;
        $('#lfl-all-latex-was-price').textContent = saving ? latex.compareText : '';
        $('#lfl-all-latex-savings').textContent = saving ? 'Save ' + latex.savingText : '';
      } else {
        $('#lfl-all-latex-compare-price').textContent = '';
        $('#lfl-all-latex-was-price').textContent = '';
        $('#lfl-all-latex-savings').textContent = '';
        $('#lfl-all-latex-unavailable-title').textContent = isTwelve ? 'No 12″ All-Latex model' : 'This combination is unavailable';
        $('#lfl-all-latex-unavailable-copy').textContent = isTwelve
          ? 'Our 2-Sided All-Latex comes in 7″ and 9″. For a 12″ option, explore our Organic Latex Mattress.'
          : selected + ' is not currently available in ' + selectedHeight + '″ All-Latex.';
      }

      $('#lfl-comparison-announcement').textContent =
        selected + ', ' + selectedHeight + ' inch. Latex Comfort ' + (comfort?.priceText || 'unavailable') +
        '. All-Latex ' + (latex?.priceText || (isTwelve ? 'has no 12-inch model' : 'unavailable')) + '.';
    }

    $('#lfl-compare-size').addEventListener('change', e => selectSize(e.target.value));
    $('#lfl-compare-height').addEventListener('change', e => selectHeight(e.target.value));
    $('#lfl-compare-view-nine').addEventListener('click', () => {
      selectHeight(9);
      $('#lfl-compare-height').focus({ preventScroll: true });
    });

    $$('[data-size]').forEach(b => b.addEventListener('click', () => selectSize(b.dataset.size)));
    $('#lfl-split-size').addEventListener('change', e => { if (e.target.value) selectSize(e.target.value); });

    $$('.thumb').forEach(b => b.addEventListener('click', () => {
      $('#lfl-gallery-main').src = b.dataset.image;
      $('#lfl-gallery-main').alt = b.dataset.alt;
      $$('.thumb').forEach(t => {
        t.classList.toggle('active', t === b);
        t.setAttribute('aria-pressed', String(t === b));
      });
    }));

    $('#lfl-zoom').addEventListener('click', () => {
      $('#lfl-zoom-image').src = $('#lfl-gallery-main').src;
      $('#lfl-zoom-image').alt = $('#lfl-gallery-main').alt;
      $('#lfl-image-dialog').showModal();
    });

    $$('[data-open]').forEach(b => b.addEventListener('click', () => root.querySelector('#' + b.dataset.open).showModal()));
    $$('[data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));

    $$('dialog').forEach(d => d.addEventListener('click', e => {
      if (e.target === d) {
        const r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      }
    }));

    $$('[data-scroll-product]').forEach(b => 
      b.addEventListener('click', () => {
        $('#lfl-product').scrollIntoView({ 
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' 
        });
        setTimeout(() => $('.sizes button.selected')?.focus({ preventScroll: true }), 450);
      })
    );

        // In-page anchor links: scroll to the target without adding #id to the URL
        root.addEventListener('click', e => {
        const a = e.target.closest('a[href^="#"]');
        if (!a || !root.contains(a)) return;

        const id = decodeURIComponent(a.getAttribute('href').slice(1));
        const target = id && document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
        });

        // Move keyboard/screen-reader focus to the section, as a normal anchor jump would
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
        });

    const feels = {
      soft: {
        kicker: 'A LITTLE MORE GIVE',
        title: 'Settle in.<br>Let the day go.',
        description: 'Cushioning natural latex gently contours around your shoulders and hips, with an easy, responsive feel as you change positions.',
        match: 'Start here if you love a more cushioned, contouring surface.',
        top: 'Softer natural latex',
        bottom: 'Flip for a firmer feel'
      },
      firm: {
        kicker: 'A LITTLE MORE LIFT',
        title: 'Feel supported.<br>Rest easy.',
        description: 'Firmer natural latex gives you a more buoyant surface, with responsive comfort that supports you as you settle in and turn over.',
        match: 'Start here if you prefer a firmer surface and a more lifted feel.',
        top: 'Firmer natural latex',
        bottom: 'Flip for a softer feel'
      }
    };

    function setFeel(b) {
      const f = feels[b.dataset.feel];
      $$('[data-feel]').forEach(t => {
        t.setAttribute('aria-selected', String(t === b));
        t.tabIndex = t === b ? 0 : -1;
      });
      $('#lfl-feel-copy').setAttribute('aria-labelledby', b.id);
      $('#lfl-feel-kicker').textContent = f.kicker;
      $('#lfl-feel-title').innerHTML = f.title;
      $('#lfl-feel-description').textContent = f.description;
      $('#lfl-feel-match').textContent = f.match;
      $('#lfl-top-side-label').textContent = f.top;
      $('#lfl-bottom-side-label').textContent = f.bottom;
    }

    $$('[data-feel]').forEach((b, i) => {
      b.addEventListener('click', () => setFeel(b));
      b.addEventListener('keydown', e => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const tabs = $$('[data-feel]');
          const next = e.key === 'Home' ? tabs[0] : e.key === 'End' ? tabs[1] : tabs[1 - i];
          setFeel(next);
          next.focus();
        }
      });
    });

    root.dataset.initialized = 'true';
    selected = initialSelection.size;
    selectHeight(initialSelection.height);
    root.classList.add('is-ready');

    // Guard missing/disabled combinations before Turbo's delegated submit handler.
    $$('.lfl-native-form').forEach(form => form.addEventListener('submit', event => {
      const p = form.dataset.lflModel === 'all-latex' ? config.allLatex : config.comfort;
      const v = p?.variants?.find(v => String(v.id) === String(form.querySelector('[name="id"]').value));
      if (!v || !v.available || v.price <= 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('#lfl-selection-status').textContent = 'This selection is unavailable. Please choose another size or height.';
      }
    }, true));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
})();